
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[location]/category/[slug]",
      function () {
        return require("private-next-pages/[language]/[location]/category/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[location]/category/[slug]"])
      });
    }
  